import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { scrollToDiv, getImageSrc } from '../../utils/helpers'

const propTypes = {
  page: PropTypes.string.isRequired,
  data: PropTypes.object.isRequired,
  scrollTo: PropTypes.string.isRequired,
}

class Hero extends Component {
  render() {
    const { page, data, scrollTo } = this.props
    const { hero_title, hero_text, hero_background } = data
    const hero_background_src = getImageSrc(hero_background)
    return (
      <section className={`hero hero--${page}`}>
        <div className="hero__text-wrapper">
          <h1 className="title title--white title--hero">{hero_title}</h1>
          <p className="title title--white title--mid">{hero_text}</p>
          <button className="button" onClick={() => scrollToDiv(scrollTo)}>
            Learn More
          </button>
        </div>
        <div className="hero__image-wrapper">
          <img
            className="hero__image"
            src={hero_background_src}
            alt="Hero Image"
          />
        </div>
      </section>
    )
  }
}

Hero.propTypes = propTypes

export default Hero



// WEBPACK FOOTER //
// ./src/components/sections/Hero.js